import { render, staticRenderFns } from "./AccountTasklist.vue?vue&type=template&id=66676a6f&scoped=true&"
import script from "./AccountTasklist.vue?vue&type=script&lang=js&"
export * from "./AccountTasklist.vue?vue&type=script&lang=js&"
import style0 from "./AccountTasklist.vue?vue&type=style&index=0&id=66676a6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66676a6f",
  null
  
)

export default component.exports